import { createDirectus, graphql, staticToken } from '@directus/sdk';
import { VideoStoryWayPoints } from '@cuevideowaypoints/core';

const CMS_URL = process.env.CMS_URL;

interface GraphqlWaypointsResult {
  languages: {
    code: string;
    name: string;
    is_default: boolean;
  }[];
  video_app_waypoints: {
    id: string;
    title: string;
    scenes: {
      sort: number;
      video_app_scenes_id: {
        id: string;
        position: string;
        name: string;

        translations?: VideoWaypointsCMSTranslation_Props[];
        info_box?: VideoWaypointsCMSInfoBoxTranslation_Props;
      };
    }[];
  }[];
}

interface VideoWaypointsCMSTranslation_Props {
  scene_name: string | null;
  languages_code: { code: string };
}

interface VideoWaypointsCMSInfoBoxTranslation_Props {
  translations: {
    headline: string | null;
    description: string | null;
    languages_code: { code: string };
  }[];
}

export const fetchWaypoints = async (): Promise<VideoStoryWayPoints | null> => {
  if (!CMS_URL) {
    console.error('NO CMS_URL');
    return null;
  }
  if (!process.env.CMS_ACCESS_TOKEN) {
    console.error('NO CMS_ACCESS_TOKEN');
    return null;
  }
  const client = createDirectus(CMS_URL)
    .with(staticToken(process.env.CMS_ACCESS_TOKEN))
    .with(graphql());

  const query = `
  query videoWaypoints {
    languages {
      code
      name
      is_default
    }
    video_app_waypoints{
      id
      title
      scenes(sort:"sort"){
        sort
        video_app_scenes_id{
          
          id
          position 
          name
          translations {
            scene_name
            languages_code {
              code
            }
          }
          info_box {
            translations {
              languages_code {
                code
              }
              headline
              description
            }
          }
        }
      }
    }
   
  }
    `;

  const result = await client.query<GraphqlWaypointsResult>(query);
  const languages = result.languages.map(({ code }) => code.split('-')[0]);
  const waypoints = result.video_app_waypoints.map((waypoint) => {
    const scenes = waypoint.scenes.map((_scene) => {
      if (!_scene.video_app_scenes_id) return;
      const { translations, info_box, ...rest } = _scene.video_app_scenes_id;
      const trans = languages.reduce((acc, lang) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        acc[lang] =
          translations?.find(({ languages_code: { code } }) => code.split('-')[0] === lang)
            ?.scene_name || rest.name;
        return acc;
      }, {});

      const trans_info_box = languages.reduce((acc, lang) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        acc[lang] = info_box?.translations?.find(
          ({ languages_code: { code } }) => code.split('-')[0] === lang,
        );
        return acc;
      }, {});
      return {
        sort: _scene.sort,
        ...rest,
        name: trans,
        info_box: trans_info_box,
      };
    });

    return {
      ...waypoint,
      scenes: scenes.filter((wp) => wp),
    };
  });
  return waypoints as unknown as VideoStoryWayPoints;
};
//fetchData();
//fetchTourData();
//fetchWaypoints();

export {};
